/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProfileUserData = {
    /**
     * Patient ID of the user. (Reference ID)
     */
    patientID?: string;
    /**
     * Weight of the user.
     */
    weight: number;
    /**
     * Weight unit of the user.
     */
    weightUnit: ProfileUserData.weightUnit;
    /**
     * Birthdate timestamp of the user.
     */
    birthdateTimestamp: number;
};
export namespace ProfileUserData {
    /**
     * Weight unit of the user.
     */
    export enum weightUnit {
        LBS = 'LBS',
        KG = 'KG',
    }
}

